import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { MoreVertical } from 'lucide-react';

const ActionMenu = ({ actions = [] }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    if (event) {
      event.stopPropagation();
    }
    setAnchorEl(null);
  };

  const handleAction = (event, action) => {
    event.stopPropagation();
    handleClose();
    if (action.onClick) {
      action.onClick();
    }
  };

  if (!actions || actions.length === 0) {
    return null;
  }

  return (
    <>
      <IconButton
        size="small"
        onClick={handleClick}
        sx={{
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
        }}
      >
        <MoreVertical size={18} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={(e) => e.stopPropagation()}
        PaperProps={{
          sx: {
            minWidth: 160,
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
            borderRadius: '8px',
          },
        }}
      >
        {actions.map((action, index) => (
          <MenuItem
            key={index}
            onClick={(e) => handleAction(e, action)}
            sx={{
              color: action.color === 'error' ? 'error.main' : 'inherit',
              '&:hover': {
                backgroundColor:
                  action.color === 'error'
                    ? 'rgba(211, 47, 47, 0.08)'
                    : 'rgba(0, 0, 0, 0.04)',
              },
            }}
          >
            {action.icon && (
              <ListItemIcon sx={{ color: 'inherit', minWidth: 36 }}>
                {action.icon}
              </ListItemIcon>
            )}
            <ListItemText>{action.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ActionMenu;
